import {
  SYSTEM_OVERVIEW_SUCCESS,
  SYSTEM_OVERVIEW_START,
  SESSION_SUCCESS,
  SESSION_START,
  SCHEDULE_START,
  SCHEDULE_SUCCESS,
  RX_START,
  RX_SUCCESS,
  TX_START,
  TX_SUCCESS,
  CONNECTION_START,
  CONNECTION_SUCCESS,
  RXGROUP_START,
  RXGROUP_SUCCESS,
  VW_START,
  VW_SUCCESS,
} from "../types/index";

const getDashboardSuccess = (data) => {
  return {
    type: SYSTEM_OVERVIEW_SUCCESS,
    systemOverview: data,
  };
};
const getDashboardStart = () => {
  return {
    type: SYSTEM_OVERVIEW_START,
  };
};

const getSessionStart = () => {
  return {
    type: SESSION_START,
  };
};

const getSessionSuccess = (data) => {
  return {
    type: SESSION_SUCCESS,
    session: data,
  };
};

const getScheduleStart = () => {
  return {
    type: SCHEDULE_START,
  };
};

const getScheduleSuccess = (data) => {
  return {
    type: SCHEDULE_SUCCESS,
    schedule: data,
  };
};

const getRXStart = () => {
  return {
    type: RX_START,
  };
};

const getRXSuccess = (data) => {
  return {
    type: RX_SUCCESS,
    rx: data,
  };
};

const getTXStart = () => {
  return {
    type: TX_START,
  };
};

const getTXSuccess = (data) => {
  return {
    type: TX_SUCCESS,
    tx: data,
  };
};

const getConnectionStart = () => {
  return {
    type: CONNECTION_START,
  };
};

const getConnectionSuccess = (data) => {
  return {
    type: CONNECTION_SUCCESS,
    connection: data,
  };
};

const getRXgroupSuccess = (data) => {
  return {
    type: RXGROUP_SUCCESS,
    rgroups: data,
  };
};
const getRXgroupStart = () => {
  return {
    type: RXGROUP_START,
  };
};

const getVWSuccess = (data) => {
  return {
    type: VW_SUCCESS,
    vws: data,
  };
};
const getVWStart = () => {
  return {
    type: VW_START,
  };
};

export {
  getDashboardSuccess,
  getDashboardStart,
  getSessionStart,
  getSessionSuccess,
  getScheduleStart,
  getScheduleSuccess,
  getRXStart,
  getRXSuccess,
  getTXStart,
  getTXSuccess,
  getConnectionStart,
  getConnectionSuccess,
  getRXgroupSuccess,
  getRXgroupStart,
  getVWStart,
  getVWSuccess,
};
